import Tooltip, {TooltipProps, tooltipClasses} from "@mui/material/Tooltip";
import {styled} from "@mui/material/styles";

/**
 * Branded tooltip with an arrow.
 *
 * Migrated from `@mui/styles` `makeStyles` (legacy JSS, unsupported on React 19) to MUI's `styled()`
 * with the `tooltipClasses` selectors — the v5+ recommended approach for restyling Tooltip.
 */
const SuperTooltip = styled(({className, ...props}: TooltipProps) => (
	<Tooltip arrow {...props} classes={{popper: className}}/>
))(({theme}) => ({
	[`& .${tooltipClasses.arrow}`]: {
		color: theme.palette.common.black,
	},
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: theme.palette.secondary.branded,
	},
}));

export default SuperTooltip;
